import React, {PropsWithChildren} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import ReviewDetail from "src/app/page/ReviewDetail";
import ReviewExport from "src/app/page/ReviewExport";
import CaseAudit from "src/app/page/CaseAudit";
import LighthouseReview from "src/app/page/LighthouseReview";
import {StringUtil} from "src/app/util/StringUtil";
import {isProdStage} from "src/app/constant/Constants";

interface RouteConfig {
    title: string,
    path: string,
    exact: boolean,
    component?: React.ComponentType,
    redirect?: string
};

const RouteConfig: RouteConfig[] = [
    {
        title: 'Home Page',
        path: '/',
        exact: true,
        redirect: '/data/export'
    },
    {
        title: 'Review Export Page',
        path: '/data/export',
        exact: true,
        component: ReviewExport
    },
    {
        title: 'Review Detail Page',
        path: '/review',
        exact: true,
        component: ReviewDetail
    },
    {
        title: 'Review Detail Page',
        path: '/review/:reviewId',
        exact: true,
        component: ReviewDetail
    },
    {
        title: 'Case Audit Page',
        path: '/case-audit',
        exact: true,
        component: CaseAudit
    },
    ...(isProdStage() ? [] : [{
        title: 'Lighthouse Review',
        path: '/lighthouse-review',
        exact: true,
        component: LighthouseReview
    }])
];

const Routes: React.FC<{}> = (props: PropsWithChildren) => {
    return (
        <Switch>
            {RouteConfig.map((route) => {
                if (!StringUtil.isNullOrEmpty(route.redirect)) {
                    const redirect = route.redirect || '/';
                    return (
                        <Route key={route.title}
                               path={route.path}
                               exact={route.exact}
                               render={() => <Redirect to={redirect}/>}/>
                    );
                } else {
                    return (
                        <Route key={route.title}
                               path={route.path}
                               exact={route.exact}
                               component={route.component}/>
                    );
                }
            })}
        </Switch>
    );
};

export default Routes;